import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import { AttributeChoiceList } from '../models/attribute_choice_list';
import * as attributeChoiceListsApi from '../api/attribute_choice_lists';
import { canEditAttributeChoiceList, reactListTablesEnabled } from '../permissions';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { translate } from '../i18n_text';
import { session } from '../session';
import { GridView } from '../utils/grid_view';
import {
  AttributeChoicesListPage,
  AttributeChoicesListProps,
  AttributeChoicesListQuery,
  AttributeChoicesListRow,
} from 'react-islands';

let template = require('raw-loader!../../templates/attribute_choice_lists.html').default;

class AttributeChoiceListsScreen implements ListLoaderDelegate<
  attributeChoiceListsApi.AttributeChoiceListData,
  AttributeChoiceList
> {
  canEdit = canEditAttributeChoiceList();
  listActions = ko.observableArray<ListHeaderAction>([]);

  newAttributeChoicesTable = reactListTablesEnabled();

  private view = new GridView('attribute-choices');

  tableProps = ko.pureComputed<AttributeChoicesListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
  }));

  constructor(params: { filters: unknown }) {
    if (this.canEdit) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/attribute_choice_lists/new/',
        tooltipTitle: i18n.t('Add attribute choice')(),
      });
    }

    if (this.newAttributeChoicesTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return attributeChoiceListsApi.list(params);
  }

  private fetchPage = (query: AttributeChoicesListQuery): Promise<AttributeChoicesListPage> =>
    this.view.fetchListPage(query, attributeChoiceListsApi.list, 'name_prefix', this);

  toRow = (choiceList: AttributeChoiceList): AttributeChoicesListRow => ({
    id: choiceList.id(),
    name: translate(choiceList.nameJson()),
    url: session.toTenantPath(choiceList.editUrl()),
    actions: delegateActions(this, choiceList, this.view.reload),
  });

  instantiate = (userData: attributeChoiceListsApi.AttributeChoiceListData) =>
    new AttributeChoiceList(userData);

  remove(id: string) {
    return attributeChoiceListsApi.remove(id);
  }

  canRemove(choiceList: AttributeChoiceList) {
    return this.canEdit;
  }
}

export let attributeChoiceLists = {
  name: 'attribute-choice-lists',
  viewModel: AttributeChoiceListsScreen,
  template: template,
};

ko.components.register(attributeChoiceLists.name, attributeChoiceLists);
